import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getAnonymousUserToken = async (
  baseUrl: string,
  config: object
) => {
  const queryPath = `${baseUrl}/token`;

  try {
    const response = await getData("", queryPath, {}, config);
    return deserialize(response.data);
  } catch (err) {
    throw new Error(err);
  }
};
